module.exports = __webpack_public_path__ + "media/images/gallery/constellations/hercules/her_dir-f6bcd2ac340fb16e58b4ba7936e85d53.gif";